import { setup } from 'xstate';

/**
 * State machine for synchronizing callback-based ReCaptcha component events
 */
export const reCaptchaStateMachine = setup({
  types: {
    events: {} as ReCaptchaMachineEvent,
  },
  guards: {
    checkIfReCaptchaEnabled: () => false,
  },
}).createMachine({
  initial: 'initializing',
  states: {
    initializing: {
      always: [{ target: 'loading', guard: 'checkIfReCaptchaEnabled' }, { target: 'disabled' }],
    },
    loading: {
      on: {
        LOAD: 'ready',
      },
    },
    ready: {
      on: {
        EXECUTE: 'executing',
      },
    },
    executing: {
      on: {
        VERIFY: 'ready',
        ERROR: 'ready',
        RESET: 'ready',
      },
    },
    disabled: {},
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ReCaptchaMachineEvent =
  | { type: 'LOAD' }
  | { type: 'EXECUTE' }
  | { type: 'VERIFY' }
  | { type: 'ERROR' }
  | { type: 'RESET' };
